import { autoinject } from 'aurelia-framework';
import { ExpressionEvaluator, getComponentViewModel, getCustomAttributeName } from 'app/shared/lib/aurelia';

export interface ITabs {
    activateTab(elementOrId: Element | string): void;
}

@autoinject()
abstract class TabCustomAttributeBase {

    public value: boolean = false;
    protected tabs: ITabs | null = null;
    protected bindingContext!: any;
    protected overrideContext!: any;

    constructor(protected readonly element: Element, private readonly expressionEvaluator: ExpressionEvaluator) { }

    protected bind(bindingContext: any, overrideContext: any) {
        this.bindingContext = bindingContext;
        this.overrideContext = overrideContext;
    }

    protected attached() {
        const tabsElement = this.element.closest('.tabs-base');
        this.tabs = tabsElement && getComponentViewModel<ITabs>(tabsElement);

        const attrName = getCustomAttributeName(this.constructor) as string;
        const attrValue = this.element.getAttribute(attrName) || this.element.getAttribute(`${attrName}.bind`);

        // If the attribute has a value, evaluate it as an Expression, otherwise treat this like a boolean attribute and its presence indicates the value is true
        const value = attrValue ? this.expressionEvaluator.evaluate(attrValue, this.bindingContext, this.overrideContext) : true;

        this.valueChanged(value);
    }

    protected abstract valueChanged(value: boolean): void;
}

export class EssActiveTabCustomAttribute extends TabCustomAttributeBase {
    protected valueChanged(value: boolean) {
        if(this.tabs && value === true) {
            this.tabs.activateTab(this.element as HTMLElement);
        }
    }
}

// NOTE: [EN] Noted from tabs-base. To be uncommented when horizontal tabs implements pinned tab
// export class EssPinnedTabCustomAttribute extends TabCustomAttributeBase {
//     protected valueChanged(value: boolean) {
//         if(this.tabs) {
//             // TODO [MW]: Consider adding `pinTab` to ITabs to make this good TS
//             (this.tabs as any).pinTab(this.element, value);
//         }
//     }
// }
